import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";

export function AuthGuard({ children }: { children: ReactNode }) {
  const token = localStorage.getItem("access_token");
  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }
  return children;
}

export function GuestGuard({ children }: { children: ReactNode }) {
  const token = localStorage.getItem("access_token");
  if (token) {
    return <Navigate to="/" replace />;
  }
  return children;
}
